import TimeRange from "@/types/time-range";
import {
  api,
  EdrObservationsMapLayerDataLocationsInner as EdrObservationsLayerLocation,
} from "@/lib/api";
import { Dimension } from "@/lib/dimensions";
import { parseStandardDataDimensions } from "@/lib/dimensions/helpers";

export type EdrObservationsLayerData = {
  dimensions: Dimension[];
  locations: EdrObservationsLayerLocation[];
};

export default class EdrObservationsLayerDataLoader {
  private dashboardId;
  private mapLayerId;

  constructor(dashboardId: string, mapLayerId: string) {
    this.dashboardId = dashboardId;
    this.mapLayerId = mapLayerId;
  }

  async loadLayerData(timeRange: TimeRange): Promise<EdrObservationsLayerData> {
    const response = await api.published.getPublishedMapLayerData(
      this.dashboardId,
      this.mapLayerId,
      timeRange.timeStart.toISOString(),
      timeRange.timeEnd.toISOString(),
    );

    return {
      dimensions: parseStandardDataDimensions(response.data.dimensions),
      locations: response.data.locations,
    };
  }
}
